module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-145.50fd83da.svg";